import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category' },
    { label: '最新入口', path: '/category/latest-access' },
    { label: '使用指南', path: '/category/usage-guide' },
    { label: '关于我们', path: '/about' },
  ],
  帮助中心: [
    { label: '常见问题', path: '/category/faq' },
    { label: '安全须知', path: '/category/security-tips' },
    { label: '平台动态', path: '/category/platform-news' },
    { label: '社区交流', path: '/category/community' },
  ],
  联系方式: [
    { label: siteInfo.email, href: `mailto:${siteInfo.email}` },
    { label: siteInfo.phone, href: `tel:${siteInfo.phone}` },
    { label: siteInfo.address, href: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-link-m text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {siteInfo.tagline}
            </p>
            <div className="flex items-center gap-3">
              <a href={siteInfo.socialMedia.weibo} className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" title={`微信：${siteInfo.socialMedia.wechat}`}>
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <a href={`tel:${siteInfo.phone}`} className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors" aria-label="电话">
                <i className="ri-phone-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.path ? (
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-background-50 transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-sm text-background-400 hover:text-background-50 transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-background-500">
          <p>&copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 保留一切权利</p>
          <div className="flex items-center gap-4">
            <span className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</span>
            <span className="hover:text-background-300 transition-colors cursor-pointer">服务条款</span>
            <span className="hover:text-background-300 transition-colors cursor-pointer">网站地图</span>
          </div>
        </div>
      </div>
    </footer>
  );
}